import actions from '../../actionTypes';

export default sorting => {
  return {
    type: actions.SET_SORTING,
    sorting
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/setSorting.js